import { useMemo } from 'react';
import gettext from '@sdk/lang/gettext';
import PickerPersonaItem from '@sdk/components/forms/PickerPersonaItem';

import { SectionHeader, FromPersonasContainer } from './mergeModal.styles';
import type { MergeModalItem } from './mergeModal.types';

type Props = {
  fromItems: MergeModalItem[];
  header: string;
  horizontal?: boolean;
  itemComponent?: (item: MergeModalItem) => JSX.Element;
};

const FromSection = ({
  fromItems,
  header,
  horizontal,
  itemComponent: ItemComponent = PickerPersonaItem,
}: Props) => {
  const items = useMemo(
    () => fromItems.map((item) => <ItemComponent {...item} key={item.id} />),
    [fromItems, ItemComponent]
  );

  return (
    <>
      <SectionHeader>{gettext(header)}</SectionHeader>
      <FromPersonasContainer horizontal={horizontal}>{items}</FromPersonasContainer>
    </>
  );
};

export default FromSection;
